import api from './api'
import type { Runner } from '../types/index'

export const runnerService = {
  async getRunners(): Promise<Runner[]> {
    const response = await api.get('/runners')
    return response.data
  },

  async getRunner(id: number): Promise<Runner> {
    const response = await api.get(`/runners/${id}`)
    return response.data
  },

  async createRunner(data: Omit<Runner, 'id' | 'createdAt' | 'updatedAt'>): Promise<Runner> {
    const response = await api.post('/runners', data)
    return response.data
  },

  async updateRunner(id: number, data: Partial<Runner>): Promise<Runner> {
    const response = await api.put(`/runners/${id}`, data)
    return response.data
  },

  async updateRunnerProfile(id: number, data: { expectedPace?: number | null; phoneNumber?: string | null; vanExchangeAlert?: boolean }): Promise<Runner> {
    const response = await api.put(`/runners/${id}/profile`, data)
    return response.data
  },

  async deleteRunner(id: number): Promise<void> {
    await api.delete(`/runners/${id}`)
  },
}
